<template>
  <div class="sankeyTab mb-5">
    <div class="tab-top mb-3">
      <span :class="['btn-comp cursor', chooseComp && 'choose']" @click="handlerComponent()">{{
        getLangValue("radar_chart.composition") }}</span>
    </div>
    <div class="tab-body">
      <template v-for="(tab, index) in tabList" :key="index">
        <b-badge :variant="currentChoose == index && tab.type" :class="[
          'badge-label rotate-180 py-2 me-3 cursor tab-label',
          index == 0 && 'ms-0',
          tab.disabled && 'disabled',
          currentChoose != index && 'not-choose',
        ]" @click="handlerChoose(index, tab)">
          <i class="mdi mdi-circle-medium"></i>
          <span :class="['tab-name rotate-180', currentChoose == index && 'choose']">{{ tab.name }}</span>
        </b-badge>
      </template>
    </div>
  </div>
  <div class="d-flex align-items-start flex-1" style="position: absolute; top: 0; right: 0" >
    <template v-for="(legend, index) in props.legends" :key="index">
      <div class="d-flex align-items-center me-3">
        <i :class="['le-icon fs-5', getIcon(legend.title)]"></i>
        <span class="le-label fs-5 font-weight-medium me-2">
          {{ legend.code? legend.code: getCode(legend.title)}}:
        </span>
        <span class="le-cont fs-6">{{ i18n.global.locale == 'en' ? legend.title_en: legend.title }}</span>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import i18n from "@/i18n"
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
  legends: {
    type: Array,
    required: true,
    default: () => []
  }
})
const tabList = [
  {
    name: getLangValue("radar_chart.feel"),
    type: "primary",
    disabled: false,
    tab: "hand",
  },
  {
    name: getLangValue("radar_chart.skin"),
    type: "secondary",
    disabled: false,
    tab: "skin",
  },
  {
    name: getLangValue("radar_chart.comfort_value"),
    type: "danger",
    disabled: false,
    tab: "heat",
  },
  {
    name: getLangValue("radar_chart.footprint"),
    type: "success",
    disabled: true,
    tab: "foot",
  },
  {
    name: getLangValue("radar_chart.recyclable"),
    type: "warning",
    disabled: true,
    tab: "recycl",
  },
]
const getIcon =(title)=> {
  switch(title){
    case '服装':
      return 'ri-shirt-fill'
      
    case '织物':
      return 'ri-map-fill'
      
    case '纱线':
      return 'ri-route-fill'
      
    case '纤维':
      return 'ri-reactjs-fill'
      
    case 'default':
      return ''
      
  }
}
const getCode =(title)=> {
  switch(title){
    case '服装':
      return 'GA'
      
    case '织物':
      return 'FA'
      
    case '纱线':
      return 'YA'
      
    case '纤维':
      return 'FI'
      
    case 'default':
      return '暂无'
      
  }
}

// const legends = [
//   {
//     label: "GA",
//     name: i18n.global.t("garment.name"),
//     icon: "ri-shirt-fill",
//     type: "garment",
//     show: false,
//   },
//   {
//     label: "FA",
//     name: i18n.global.t("fabric.name"),
//     icon: "ri-map-fill ",
//     type: "fabric",
//     show: false,
//   },
//   {
//     label: "YA",
//     name: i18n.global.t("yarn.name"),
//     icon: "ri-route-fill",
//     type: "yarn",
//     show: false,
//   },
//   {
//     label: "FI",
//     name: i18n.global.t("fiber.name"),
//     icon: "ri-reactjs-line",
//     type: "fibre",
//     show: false,
//   },
//   {
//     label: "HO",
//     name: i18n.global.t("hometextile.name"),
//     icon: "ri-hotel-bed-fill",
//     type: "hometextile",
//     show: false,
//   },
//   {
//     label: "TE",
//     name: i18n.global.t("textile.name"),
//     icon: "ri-scissors-cut-fill",
//     type: "textile",
//     show: false,
//   },
// ];
const currentTab = ref("hand")
const currentChoose = ref("")
const chooseComp = ref(true)
const handlerComponent = () => {
  if (currentTab.value) {
    chooseComp.value = true;
    currentChoose.value = null;
    // this.$emit("update:currentTab", "");
  }
}
const handlerChoose = (index, tabInfo) => {
  if (!tabInfo.disabled) {
    if (currentChoose.value == index) {
      currentChoose.value = null;
      // this.$emit("update:currentTab", "");
    } else {
      currentChoose.value = index;
      // this.$emit("update:currentTab", tabInfo.tab);
    }
  }
}

</script>

<style scoped lang='scss'>
.mdi {
  color: #fff;
}

.btn-comp {
  background-color: #e9e9e9;
  border-radius: 5px;
  color: #000;
  padding: 5px 20px;

  &.choose {
    background-color: #299cdb;
  }
}

.tab-name {
  color: #000;
  font-weight: 400;
  display: inline-block;
}

.rotate-180 {
  transform: rotate(180deg);
}

.tab-label {
  background-color: #e9e9e9;
}

.not-choose {
  &.badge-label:before {
    border-right-color: #e9e9e9;
  }
}

.choose {
  color: #fff;
}

.disabled {
  opacity: 1;
  cursor: not-allowed;
}

.le-icon {
  color: #56c3fa;
}

.le-cont {
  color: #495057;
}
</style>
